


//   import React, { useEffect, useState, useCallback } from "react";
// import axiosAuth from "../api/axiosAuth";
// import io from "socket.io-client";
// import { useAuth } from "../context/AuthContext";
// import { API } from "../components/config";
// import "../style/MisAsignaciones.css";

// const SOCKET_URL =
//   process.env.REACT_APP_API_SOCKET ||
//   "http://3.236.217.225:5001";

// function MisAsignaciones() {
//   const { user, token } = useAuth();

//   const profesorId = user?.id;
//   const tenantId = user?.tenant_id || user?.institucion_id;
//   const sedeId = user?.sede_id;

//   const [asignaciones, setAsignaciones] = useState([]);
//   const [cargando, setCargando] = useState(true);
//   const [error, setError] = useState("");

//   /* =====================================================
//      📡 FETCH ASIGNACIONES
//   ===================================================== */
//   const fetchAsignaciones = useCallback(async () => {
//     if (!profesorId || !token) return;

//     try {
//       setCargando(true);
//       setError("");

//       const res = await axiosAuth.get(
//         `${API}/asignaciones/profesor`
//       );

//       setAsignaciones(Array.isArray(res.data) ? res.data : []);
//     } catch (err) {
//       console.error("❌ Error al cargar asignaciones:", err);
//       setError("No se pudo cargar la carga académica.");
//     } finally {
//       setCargando(false);
//     }
//   }, [profesorId, token]);

//   /* =====================================================
//      🔌 SOCKET REAL TIME
//   ===================================================== */
//   useEffect(() => {
//     if (!profesorId || !token) return;

//     const socket = io(SOCKET_URL, {
//       auth: { token },
//       query: { tenantId, sedeId }
//     });

//     socket.emit("registrarUsuario", {
//       id: profesorId,
//       role: "profesor",
//       tenantId,
//       sedeId
//     });

//     // ➕ nueva asignación
//     socket.on("nueva-asignacion", (nueva) => {
//       setAsignaciones((prev) => {
//         const existe = prev.some((a) => a.id === nueva.id);
//         return existe ? prev : [nueva, ...prev];
//       });
//     });

//     // ✏️ actualizar
//     socket.on("actualizar-asignacion", (actualizada) => {
//       setAsignaciones((prev) =>
//         prev.map((a) =>
//           a.id === actualizada.id ? actualizada : a
//         )
//       );
//     });

//     // ❌ eliminar
//     socket.on("eliminar-asignacion", ({ id }) => {
//       setAsignaciones((prev) =>
//         prev.filter((a) => a.id !== id)
//       );
//     });

//     return () => {
//       socket.off("nueva-asignacion");
//       socket.off("actualizar-asignacion");
//       socket.off("eliminar-asignacion");
//       socket.disconnect();
//     };
//   }, [profesorId, token, tenantId, sedeId]);

//   /* =====================================================
//      🔄 INIT
//   ===================================================== */
//   useEffect(() => {
//     fetchAsignaciones();
//   }, [fetchAsignaciones]);

//   /* =====================================================
//      ⚠️ VALIDACIÓN SESIÓN
//   ===================================================== */
//   if (!profesorId) {
//     return (
//       <div className="mensaje-alerta">
//         <p>⚠️ Sesión no válida. Inicia sesión nuevamente.</p>
//       </div>
//     );
//   }

//   /* =====================================================
//      UI
//   ===================================================== */
//   return (
//     <div className="mis-asignaciones-container fade-in">

//       <header className="asignaciones-header">
//         <h2>📚 Mis Asignaciones Académicas</h2>
//         <p className="subtitle">
//           Cursos y materias asignadas
//         </p>
//       </header>

//       {error && (
//         <div className="error-banner">{error}</div>
//       )}

//       {cargando ? (
//         <div className="loading-state">
//           <div className="spinner"></div>
//           <p>Cargando asignaciones...</p>
//         </div>
//       ) : (
//         <div className="content-wrapper">

//           <div className="stats-bar">
//             <span>
//               Total: <strong>{asignaciones.length}</strong>
//             </span>

//             <button onClick={fetchAsignaciones}>
//               🔄
//             </button>
//           </div>

//           <div className="tabla-responsive">
//             <table className="tabla-asignaciones">

//               <thead>
//                 <tr>
//                   <th>ID</th>
//                   <th>Materia</th>
//                   <th>Grado / Grupo</th>
//                   <th>Sede</th>
//                   <th>Estado</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {asignaciones.length === 0 ? (
//                   <tr>
//                     <td colSpan="5">
//                       No tienes asignaciones.
//                     </td>
//                   </tr>
//                 ) : (
//                   asignaciones.map((a) => (
//                     <tr key={a.id}>
//                       <td>#{a.id}</td>
//                       <td>
//            <strong>
//   {a.materia_nombre || a.materia || "Sin materia"}
// </strong>

//                       </td>
//                       <td>
//                         {a.grado}°{a.grupo}
//                       </td>
//                       <td>
//                         {a.sede_nombre || "Principal"}
//                       </td>
//                       <td>
//                         <span className="status-pill active">
//                           Activo
//                         </span>
//                       </td>
//                     </tr>
//                   ))
//                 )}
//               </tbody>

//             </table>
//           </div>

//         </div>
//       )}
//     </div>
//   );
// }

// export default MisAsignaciones;


import React, { useEffect, useState, useCallback } from "react";
import axiosAuth from "../api/axiosAuth";
import io from "socket.io-client";
import { useAuth } from "../context/AuthContext";
import { API } from "../components/config";
import "../style/MisAsignaciones.css";

const SOCKET_URL =
  process.env.REACT_APP_API_SOCKET ||
  "http://3.236.217.225:5001";

function MisAsignaciones() {
  const { user, token } = useAuth();

  const profesorId = user?.id;
  const tenantId =
    user?.tenant_id ||
    user?.institucion_id;

  const sedeId = user?.sede_id;

  const [asignaciones, setAsignaciones] =
    useState([]);

  const [cargando, setCargando] =
    useState(true);

  const [error, setError] =
    useState("");

  /* ==========================================
     CARGAR ASIGNACIONES
  ========================================== */

  const fetchAsignaciones =
    useCallback(async () => {

      if (!profesorId || !token) {
        return;
      }

      try {

        setCargando(true);
        setError("");

        const res = await axiosAuth.get(
          `${API}/asignaciones/profesor`
        );

        console.log(
          "📚 Respuesta API asignaciones:",
          res.data
        );

        const lista =
          res.data?.asignaciones || [];

        console.log(
          "📚 Asignaciones cargadas:",
          lista
        );

        setAsignaciones(lista);

      } catch (err) {

        console.error(
          "❌ Error al cargar asignaciones:",
          err
        );

        setError(
          "No se pudo cargar la carga académica."
        );

      } finally {

        setCargando(false);

      }

    }, [profesorId, token]);

  /* ==========================================
     DEBUG
  ========================================== */

  useEffect(() => {

    console.log(
      "📚 Estado asignaciones:",
      asignaciones
    );

  }, [asignaciones]);

  /* ==========================================
     SOCKET
  ========================================== */

  useEffect(() => {

    if (!profesorId || !token) {
      return;
    }

    const socket = io(
      SOCKET_URL,
      {
        auth: { token },
        query: {
          tenantId,
          sedeId
        }
      }
    );

    socket.emit(
      "registrarUsuario",
      {
        id: profesorId,
        role: "profesor",
        tenantId,
        sedeId
      }
    );

    socket.on(
      "nueva-asignacion",
      (nueva) => {

        setAsignaciones(prev => {

          const existe =
            prev.some(
              a => a.id === nueva.id
            );

          return existe
            ? prev
            : [nueva, ...prev];

        });

      }
    );

    socket.on(
      "actualizar-asignacion",
      (actualizada) => {

        setAsignaciones(prev =>
          prev.map(a =>
            a.id === actualizada.id
              ? actualizada
              : a
          )
        );

      }
    );

    socket.on(
      "eliminar-asignacion",
      ({ id }) => {

        setAsignaciones(prev =>
          prev.filter(
            a => a.id !== id
          )
        );

      }
    );

    return () => {

      socket.off(
        "nueva-asignacion"
      );

      socket.off(
        "actualizar-asignacion"
      );

      socket.off(
        "eliminar-asignacion"
      );

      socket.disconnect();

    };

  }, [
    profesorId,
    token,
    tenantId,
    sedeId
  ]);

  /* ==========================================
     INICIALIZAR
  ========================================== */

  useEffect(() => {

    fetchAsignaciones();

  }, [fetchAsignaciones]);

  /* ==========================================
     VALIDAR SESIÓN
  ========================================== */

  if (!profesorId) {

    return (
      <div className="mensaje-alerta">
        <p>
          ⚠️ Sesión no válida.
          Inicia sesión nuevamente.
        </p>
      </div>
    );

  }

  /* ==========================================
     UI
  ========================================== */

  return (
    <div className="mis-asignaciones-container fade-in">

      <header className="asignaciones-header">
        <h2>
          📚 Mis Asignaciones Académicas
        </h2>

        <p className="subtitle">
          Cursos y materias asignadas
        </p>
      </header>

      {error && (
        <div className="error-banner">
          {error}
        </div>
      )}

      {cargando ? (

        <div className="loading-state">
          <div className="spinner"></div>
          <p>
            Cargando asignaciones...
          </p>
        </div>

      ) : (

        <div className="content-wrapper">

          <div className="stats-bar">
            <span>
              Total:
              <strong>
                {" "}
                {asignaciones.length}
              </strong>
            </span>

            <button
              onClick={
                fetchAsignaciones
              }
            >
              🔄
            </button>
          </div>

          <div className="tabla-responsive">

            <table className="tabla-asignaciones">

              <thead>
                <tr>
                  <th>ID</th>
                  <th>Materia</th>
                  <th>Grado / Grupo</th>
                  <th>Sede</th>
                  <th>Estado</th>
                </tr>
              </thead>

              <tbody>

                {asignaciones.length === 0 ? (

                  <tr>
                    <td colSpan="5">
                      No tienes asignaciones.
                    </td>
                  </tr>

                ) : (

                  asignaciones.map(a => (

                    <tr key={a.id}>

                      <td>
                        #{a.id}
                      </td>

                      <td>
                        <strong>
                          {
                            a.materia_nombre ||
                            a.materia ||
                            "Sin materia"
                          }
                        </strong>
                      </td>

                      <td>
                        {a.grado}°
                        {a.grupo}
                      </td>

                      <td>
                        {
                          a.sede_nombre ||
                          "Principal"
                        }
                      </td>

                      <td>
                        <span className="status-pill active">
                          Activo
                        </span>
                      </td>

                    </tr>

                  ))

                )}

              </tbody>

            </table>

          </div>

        </div>

      )}

    </div>
  );
}

export default MisAsignaciones;

